const $ = require('jquery');
const filtersBlock = $('.filters-block'),
    filtersContainer = filtersBlock.find('.filters-container'),
    menuToggle = filtersBlock.find('.sticky-toggle'),
    breakpointMd = 768;

$(document).ready(function () {
    $(window).on("load resize scroll", function (e) {
        if ($('#results').length) {
            e.preventDefault();
            let resultsBlockTop = $('#results').offset().top,
                window = $(this),
                windowTop = window.scrollTop();

            windowTop >= resultsBlockTop ? filtersBlock.addClass('sticky') : filtersBlock.removeClass('sticky');

            if (window.width() <= breakpointMd) {
                if (windowTop < resultsBlockTop) {
                    filtersContainer.show();
                    menuToggle.removeClass('active');
                } else {
                    if (filtersBlock.hasClass('sticky') && menuToggle.hasClass('active')) {
                        filtersContainer.show();
                    } else {
                        filtersContainer.hide();
                    }
                }
            } else {
                filtersContainer.show();
            }
        }
    });

    if ($('#results').length) {
        menuToggle.on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('active');
            if ($(this).hasClass('active')) {
                filtersContainer.fadeIn();
            } else {
                filtersContainer.fadeOut();
            }
        });
    }
});
